// Hardcoded by default across all application and configs

export const ZP_CLIENT_ID = 'M4OJP5EUM28VNV0E5RSC7JK21URA8FVL2LPIQFF2T36CUMF8PU3Q1MFGL866MJ06';
export const ZP_REDIRECT_URI = 'https://zarplata.ru';
